module.exports = __webpack_public_path__ + "img/capacitor-magenta.df89b195.png";